import { type FunctionComponent } from 'react';

import { Field } from '@kanda-libs/ks-component-ts';
import { Button } from '@kanda-libs/ks-design-library';

import useOmniSignDocumentsFormBasePageSignDocument from './useOmniSignDocumentsFormBasePageSignDocument';

import { BasePage } from '../constants';

interface OmniSignDocumentsFormBasePageSignDocumentProps {
  page: BasePage;
  scrollRef: React.MutableRefObject<HTMLDivElement | null>;
  isSubmitting: boolean;
}

const OmniSignDocumentsFormBasePageSignDocument: FunctionComponent<
  OmniSignDocumentsFormBasePageSignDocumentProps
> = ({ page, scrollRef, isSubmitting }) => {
  const { tickboxProps, buttonProps } =
    useOmniSignDocumentsFormBasePageSignDocument(page, scrollRef);
  return (
    <div className="flex flex-col mt-10">
      <Field.FingerprintBooleanInput {...tickboxProps} />
      <Button.Text {...buttonProps} disabled={isSubmitting} />
    </div>
  );
};

export default OmniSignDocumentsFormBasePageSignDocument;
